const FigmaLogo = ({ width = 75, height = 75 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1333_2389)">
          <path
            d="M35.5469 101.474C44.8438 101.474 52.3438 93.9736 52.3438 84.6768V67.8799H35.5469C26.25 67.8799 18.75 75.3799 18.75 84.6768C18.75 93.9736 26.25 101.474 35.5469 101.474Z"
            fill="#0ACF83"
          />
          <path
            d="M18.75 51.083C18.75 41.7861 26.25 34.2861 35.5469 34.2861H52.3438V67.8799H35.5469C26.25 67.8799 18.75 60.3799 18.75 51.083Z"
            fill="#A259FF"
          />
          <path
            d="M18.75 17.4893C18.75 8.19238 26.25 0.692383 35.5469 0.692383H52.3438V34.2861H35.5469C26.25 34.2861 18.75 26.7861 18.75 17.4893Z"
            fill="#F24E1E"
          />
          <path
            d="M52.3438 0.692383H69.1406C78.4375 0.692383 85.9375 8.19238 85.9375 17.4893C85.9375 26.7861 78.4375 34.2861 69.1406 34.2861H52.3438V0.692383Z"
            fill="#FF7262"
          />
          <path
            d="M85.9375 51.083C85.9375 60.3799 78.4375 67.8799 69.1406 67.8799C59.8438 67.8799 52.3438 60.3799 52.3438 51.083C52.3438 41.7861 59.8438 34.2861 69.1406 34.2861C78.4375 34.2861 85.9375 41.7861 85.9375 51.083Z"
            fill="#1ABCFE"
          />
        </g>
        <defs>
          <clipPath id="clip0_1333_2389">
            <rect
              width="100"
              height="100"
              fill="white"
              transform="translate(0 0.692383)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  
  export default FigmaLogo;
  